// Floats palette — every adjacent pair is distinguishable to viewers with
// color-vision deficiency (checked against deuteranopia/protanopia
// simulators). Don't replace #1a41b8 back next to #13319a — they look
// identical in print and at small sizes.
export const FLOATS_PALETTE = [
  "#13319a", // 0 navy        — primary brand
  "#e50b71", // 1 magenta     — secondary brand
  "#f59e0b", // 2 amber
  "#10b981", // 3 emerald
  "#0891b2", // 4 cyan
  "#9333ea", // 5 purple
  "#dc2626", // 6 red
  "#0d9488", // 7 teal
  "#6b21a8", // 8 plum
  "#1a41b8", // 9 royal blue  — was at index 2, demoted to avoid clash with #0
];
